module.exports = __webpack_public_path__ + "img/inland_valley.70919e4f.jpg";